<mat-progress-bar
  *ngIf="!loading" color="warn" mode="indeterminate">
</mat-progress-bar>
<div *ngIf="!loading"  id="spacing">
    <img src="assets/splash/back.png" alt="" id="back" class="d-block mx-auto">
    <img src="assets/splash/logo.png" alt="" id="front" class="d-block mx-auto">
</div>
<router-outlet *ngIf="loading"></router-outlet>
